module.exports = __webpack_public_path__ + "img/_Mooney.52c0486c.png";